export default "__VITE_ASSET__SDP1h5nz__"